// extracted by mini-css-extract-plugin
export default {"container":"DocumentSubmission-module__container--TjKQg","content":"DocumentSubmission-module__content--yO6xP"};